import { SCHOOL_BROCHURE_LEVELS, schoolBrochureMessage, schoolBrochures, type SchoolBrochureLevel } from "@rutamagica/contracts";
import { ExternalLink, FileText, Send, Zap } from "lucide-react";
import { useState } from "react";
import { Button, Dialog } from "../../components/ui";

/**
 * Ready-made actions for the chat. Today: send the school brochure of any level with a text.
 * The text starts from a template and can be edited before sending.
 */
export function QuickActions({ customerName, disabled, onSendBrochure }: {
  customerName: string;
  disabled: boolean;
  onSendBrochure: (level: SchoolBrochureLevel, caption: string) => Promise<void>;
}) {
  const [open, setOpen] = useState(false);
  const [level, setLevel] = useState<SchoolBrochureLevel>("primaria");
  const [caption, setCaption] = useState(() => schoolBrochureMessage("primaria", customerName));
  const [edited, setEdited] = useState(false);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");
  const choose = (next: SchoolBrochureLevel) => {
    setLevel(next);
    if (!edited) setCaption(schoolBrochureMessage(next, customerName));
  };
  const send = async () => {
    setWorking(true);
    setError("");
    try {
      await onSendBrochure(level, caption.trim());
      setOpen(false);
      setEdited(false);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "No pudimos enviar el brochure.");
    } finally {
      setWorking(false);
    }
  };
  return (
    <>
      <Button variant="secondary" icon={Zap} disabled={disabled} onClick={() => { setCaption(schoolBrochureMessage(level, customerName)); setEdited(false); setOpen(true); }}>
        Acciones rápidas
      </Button>
      <Dialog open={open} title="Enviar brochure escolar" eyebrow="Acciones rápidas" size="medium" onClose={() => { if (!working) setOpen(false); }}>
        <div className="quick-actions">
          <p className="report-explainer">Elige el nivel; el PDF se envía por WhatsApp junto con el texto.</p>
          <div className="funnel-chips" role="group" aria-label="Nivel académico">
            {SCHOOL_BROCHURE_LEVELS.map((item) => (
              <button key={item} type="button" className="funnel-chip" aria-pressed={item === level} onClick={() => choose(item)}>
                {schoolBrochures[item].label}
              </button>
            ))}
          </div>
          <a className="button button--quiet" href={`/api/v1/brochures/${level}`} target="_blank" rel="noreferrer">
            <FileText size={16} aria-hidden="true" /> Ver brochure de {schoolBrochures[level].label} <ExternalLink size={14} aria-hidden="true" />
          </a>
          <label className="crm-textarea-field">
            <span>Texto que acompaña al PDF</span>
            <textarea value={caption} maxLength={1200} rows={5} onChange={(e) => { setCaption(e.target.value); setEdited(true); }} />
          </label>
          {error && <p role="alert" className="case-chat__error">{error}</p>}
          <div className="case-actions">
            <Button icon={Send} disabled={working || !caption.trim()} onClick={() => void send()}>
              {working ? "Enviando…" : "Enviar por WhatsApp"}
            </Button>
            <Button variant="quiet" disabled={working} onClick={() => setOpen(false)}>Cancelar</Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
